import { render, staticRenderFns } from "./AnimatedFlexBox.vue?vue&type=template&id=58757cc4&scoped=true&"
var script = {}
import style0 from "./AnimatedFlexBox.vue?vue&type=style&index=0&id=58757cc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58757cc4",
  null
  
)

export default component.exports